import { render, staticRenderFns } from "./DemoChoosePharmacy.vue?vue&type=template&id=29fe5d5b"
import script from "./DemoChoosePharmacy.vue?vue&type=script&lang=js"
export * from "./DemoChoosePharmacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports